import React from 'react';
import { useIntl } from 'react-intl';
import DropdownCell from '@/components/table/DropdownCell';
import matchAttachmentType, { attachmentViewingOptions, confirmDownloadable } from '../helper';
import Events from '../hooks/events';
import { ATTACHMENT_TYPE } from '../constants';

const listItems = (options, intl) => (
  Object.values(options).sort((a, b) => a.order - b.order).map(({ name, icon, className }) => ({
    className,
    icon,
    key: `dataset_attachments_viewing_${name}`,
    text: intl.formatMessage({ id: `dataset.attachments.viewing.${name}` }),
    value: name,
  }))
);

const AttachmentViewingCell = ({
  attachment,
  category,
  code,
  disabled,
  isLoading,
  upward,
}) => {
  const intl = useIntl();
  const showDownloadableConfirmation = Events.useShowDownloadableConfirmationDialog(category, { code });
  const updateMetadata = Events.useUpdateDatasetAttachmentMetadata({ category, code });
  const { metadata, id: attachmentId } = attachment;

  const onAttachmentViewingChange = (viewing) => {
    if (confirmDownloadable(attachment, viewing)) {
      showDownloadableConfirmation({ attachmentId, isFolder: matchAttachmentType(attachment, ATTACHMENT_TYPE.folder) });
    } else { updateMetadata({ attachmentId, metadata: { viewing } }); }
  };

  return (
    <DropdownCell
      className="primary"
      disabled={disabled}
      isLoading={isLoading}
      onChange={(e, { value }) => onAttachmentViewingChange(value)}
      options={listItems(attachmentViewingOptions(attachment), intl)}
      upward={upward}
      value={metadata.viewing}
    />
  );
};

export default AttachmentViewingCell;
